// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* custom-editor-styles.css */

/* Center alignment for custom image, video, and embed formats */
.ql-custom-image,
.ql-custom-video,
.ql-custom-embed {
  display: block;
  margin: 0 auto; /* Horizontal center alignment */
}

.ql-container {
  height: 100% !important; /* Ensure the editor container has a fixed height */
  overflow: hidden; /* Prevent container scrolling */
  display: flex; /* Ensures proper alignment */
  flex-direction: column;
}

.ql-editor {
  flex-grow: 1; /* Allow the editor to use the remaining height */
  overflow-y: auto; /* Enable scrolling within the editor */
  padding: 12px; /* Add padding for better spacing */
  box-sizing: border-box; /* Ensure padding doesn’t affect height */
}

.ql-toolbar {
  flex-shrink: 0; /* Prevent toolbar from shrinking */
  border-radius: 4px 4px 0 0; /* Round toolbar corners */
  z-index: 1 !important;

}

.ql-container {
  border-radius: 0 0 4px 4px; /* Round editor container corners */
}
`, "",{"version":3,"sources":["webpack://./src/config/component/Editor/style.css"],"names":[],"mappings":"AAAA,6BAA6B;;AAE7B,gEAAgE;AAChE;;;EAGE,cAAc;EACd,cAAc,EAAE,gCAAgC;AAClD;;AAEA;EACE,uBAAuB,EAAE,mDAAmD;EAC5E,gBAAgB,EAAE,gCAAgC;EAClD,aAAa,EAAE,6BAA6B;EAC5C,sBAAsB;AACxB;;AAEA;EACE,YAAY,EAAE,iDAAiD;EAC/D,gBAAgB,EAAE,uCAAuC;EACzD,aAAa,EAAE,mCAAmC;EAClD,sBAAsB,EAAE,yCAAyC;AACnE;;AAEA;EACE,cAAc,EAAE,mCAAmC;EACnD,0BAA0B,EAAE,0BAA0B;EACtD,qBAAqB;;AAEvB;;AAEA;EACE,0BAA0B,EAAE,mCAAmC;AACjE","sourcesContent":["/* custom-editor-styles.css */\r\n\r\n/* Center alignment for custom image, video, and embed formats */\r\n.ql-custom-image,\r\n.ql-custom-video,\r\n.ql-custom-embed {\r\n  display: block;\r\n  margin: 0 auto; /* Horizontal center alignment */\r\n}\r\n\r\n.ql-container {\r\n  height: 100% !important; /* Ensure the editor container has a fixed height */\r\n  overflow: hidden; /* Prevent container scrolling */\r\n  display: flex; /* Ensures proper alignment */\r\n  flex-direction: column;\r\n}\r\n\r\n.ql-editor {\r\n  flex-grow: 1; /* Allow the editor to use the remaining height */\r\n  overflow-y: auto; /* Enable scrolling within the editor */\r\n  padding: 12px; /* Add padding for better spacing */\r\n  box-sizing: border-box; /* Ensure padding doesn’t affect height */\r\n}\r\n\r\n.ql-toolbar {\r\n  flex-shrink: 0; /* Prevent toolbar from shrinking */\r\n  border-radius: 4px 4px 0 0; /* Round toolbar corners */\r\n  z-index: 1 !important;\r\n\r\n}\r\n\r\n.ql-container {\r\n  border-radius: 0 0 4px 4px; /* Round editor container corners */\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
